/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { observer } from 'mobx-react';
import * as React from 'react';

import { labelGroup } from '../utilities/order-lookup-utility';

/**
 * Input field props.
 */
export interface IOrderLookupFieldInfoInput {
    inputReference?: React.RefObject<HTMLInputElement>;
    className: string;
    ariaLabel: string;
    inputType: string;
    value: string;
    name: string;
    orderLookupLabel: string;
    orderLookupLabelClassName: string;
    fieldErrorClassName: string;
    isInputTypeError: boolean;
    isValidInputField: boolean;
    renderAlert(className: string): JSX.Element;
    onChange(event: React.ChangeEvent<HTMLInputElement>): void;
}

/**
 * Order lookup field props.
 */
export interface IOrderLookupFieldInfo {
    label: React.ReactNode;
    input: React.ReactNode;
    error: React.ReactNode;
}

/**
 * RenderOrderLookupInputs component.
 */
@observer
export default class RenderOrderLookupFormFields extends React.Component<IOrderLookupFieldInfoInput> {
    public constructor(props: IOrderLookupFieldInfoInput) {
        super(props);
    }

    public shouldComponentUpdate(nextProps: IOrderLookupFieldInfoInput): boolean {
        if (this.props === nextProps) {
            return false;
        }
        return true;
    }

    public render(): JSX.Element | undefined {
        return (
            <div className={this.props.className}>
                {this._getOrderLookupFields().label}
                {this._getOrderLookupFields().error}
                {this._getOrderLookupFields().input}
            </div>
        );
    }

    /**
     * Function to create the order lookup fields.
     * @returns IOrderLookupFieldInfo.
     */
    private _getOrderLookupFields(): IOrderLookupFieldInfo {
        return {
            label: labelGroup(this.props.orderLookupLabelClassName, this.props.orderLookupLabel),
            input: (
                <div className='ms-order-lookup__details__form__fields__input-detail'>
                    <input
                        ref={this.props.inputReference}
                        type={this.props.inputType}
                        onChange={this.props.onChange}
                        aria-label={this.props.ariaLabel}
                        value={this.props.value}
                        name={this.props.name}
                    />
                </div>
            ),
            error: (
                <div className={this.props.fieldErrorClassName}>
                    {this.props.isInputTypeError ? this.props.renderAlert(this.props.name) : ''}
                    {this.props.isValidInputField ? this.props.renderAlert(this.props.name) : ''}
                </div>
            )
        };
    }
}
